var _clipPath;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRCartBuy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconR-cart-buy-disc",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    style: {
      fill: "none"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    style: {
      fill: "#135985"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.849,25.497c-1.155,0 -2.093,0.938 -2.093,2.094c-0,1.155 0.938,2.094 2.093,2.094c1.156,-0 2.094,-0.939 2.094,-2.094c-0,-1.156 -0.938,-2.094 -2.094,-2.094Zm11.929,-0.004c-1.156,0 -2.094,0.939 -2.094,2.094c-0,1.156 0.938,2.094 2.094,2.094c1.155,-0 2.093,-0.938 2.093,-2.094c0,-1.155 -0.938,-2.094 -2.093,-2.094Zm-14.122,-12.582c0,0 -2.126,-0.012 -2.129,-0.012c-0.26,-0 -0.527,-0.26 -0.527,-0.546l0,-0.49c0,-0.28 0.27,-0.538 0.527,-0.538c0.002,0 2.716,0.012 2.716,0.012c0,0 0.551,-0.001 0.748,0.538c0.274,0.749 0.294,0.796 0.382,1.037c0.256,-0 0.827,-0.001 2.317,-0.001c0.022,0 0.043,0.009 0.059,0.024c0.015,0.016 0.024,0.037 0.024,0.06l0,1.406c0,0.046 -0.037,0.084 -0.083,0.084c-0,-0 -1.748,0.004 -1.748,0.004l3.382,9.292c0,-0 12.067,-2.797 12.067,-2.797c-0,0 -0,-6.502 -0,-6.502l-1.421,-0c-0.046,-0 -0.084,-0.038 -0.084,-0.084l0,-1.403c0,-0.023 0.009,-0.044 0.025,-0.06c0.016,-0.015 0.037,-0.024 0.059,-0.024l1.974,0.001c0.554,-0.001 1.056,0.524 1.056,1.048c0,0.011 -0.003,5.662 -0.003,7.338c-0,0.911 -0.765,1.116 -0.983,1.173c0,-0 -12.154,2.792 -13.056,2.999c-0.184,0.042 -0.317,0.01 -0.354,0.005c-0.404,-0.063 -0.527,-0.414 -0.548,-0.463c0,0 -4.084,-11.227 -4.4,-12.101Zm10.007,6.265c-0.05,-0.01 -0.152,-0.045 -0.152,-0.045c-0.05,-0.021 -0.093,-0.044 -0.133,-0.07c0,-0 -0.003,-0.002 -0.005,-0.003c-0.047,-0.032 -0.087,-0.065 -0.124,-0.102l-2.583,-2.583c-0.145,-0.145 -0.235,-0.345 -0.235,-0.566c0,-0.442 0.359,-0.8 0.801,-0.8c0.22,0 0.421,0.09 0.565,0.235l1.218,1.217l0,-4.843c0,-0.442 0.358,-0.801 0.8,-0.801c0.442,0 0.801,0.359 0.801,0.801l-0,4.843l1.217,-1.217c0.145,-0.145 0.345,-0.235 0.566,-0.235c0.442,0 0.8,0.358 0.8,0.8c0,0.221 -0.089,0.421 -0.234,0.566l-2.583,2.583c-0.037,0.037 -0.078,0.07 -0.121,0.099l-0.136,0.074c-0,0 -0.012,0.004 -0.016,0.006c-0.039,0.016 -0.144,0.042 -0.146,0.042c-0.045,0.009 -0.096,0.014 -0.148,0.014c-0.052,0 -0.102,-0.005 -0.152,-0.015Z",
    style: {
      fill: "#fff"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRCartBuy);
export default __webpack_public_path__ + "static/media/iconR-cart-buy.927ff5d1d4b3e2e79be502633046b7e8.svg";
export { ForwardRef as ReactComponent };